import { AssetPopularDestinationsBase } from './asset-popular-destinations.base';

export const AssetPopularDestinations = {
  ...AssetPopularDestinationsBase,
  FLIGHTS: [
    'RIO', 'SAO', 'FOR', 'REC', 'LIS', 'BUE',
  ],
  HOTELS: [
    'RIO', 'SAO', 'SSA', 'FOR', 'NYC', 'MIA',
  ],
  AUTOS: [
    'SAO', 'RIO', 'NAT', 'MIA', 'MCO', 'SCL'
  ],
  BUSES: [],
  PACKAGES: [
    'RIO', 'FOR', 'MCZ', 'BUE', 'CUN', 'PUJ'
  ],
  TOUR_AND_ACTIVITIES: [
    'RIO', 'IGU', 'SAO', 'SSA', 'MAO', 'REC'
  ],
};
